/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { organizationRemoteSessionClientsAttachKeySet } from "../funcs/organizationRemoteSessionClientsAttachKeySet.js";
import { organizationRemoteSessionClientsCreate } from "../funcs/organizationRemoteSessionClientsCreate.js";
import { organizationRemoteSessionClientsCreateCimd } from "../funcs/organizationRemoteSessionClientsCreateCimd.js";
import { organizationRemoteSessionClientsDelete } from "../funcs/organizationRemoteSessionClientsDelete.js";
import { organizationRemoteSessionClientsDetachKeySet } from "../funcs/organizationRemoteSessionClientsDetachKeySet.js";
import { organizationRemoteSessionClientsGet } from "../funcs/organizationRemoteSessionClientsGet.js";
import { organizationRemoteSessionClientsGetDelegationStatus } from "../funcs/organizationRemoteSessionClientsGetDelegationStatus.js";
import { organizationRemoteSessionClientsGetDeletePreflight } from "../funcs/organizationRemoteSessionClientsGetDeletePreflight.js";
import { organizationRemoteSessionClientsList } from "../funcs/organizationRemoteSessionClientsList.js";
import { organizationRemoteSessionClientsListMcpServers } from "../funcs/organizationRemoteSessionClientsListMcpServers.js";
import { organizationRemoteSessionClientsRemoveFromMcpServer } from "../funcs/organizationRemoteSessionClientsRemoveFromMcpServer.js";
import { organizationRemoteSessionClientsRotate } from "../funcs/organizationRemoteSessionClientsRotate.js";
import { organizationRemoteSessionClientsUpdate } from "../funcs/organizationRemoteSessionClientsUpdate.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { ListOrganizationMcpServersResult } from "../models/components/listorganizationmcpserversresult.js";
import { OrganizationClientDelegationStatus } from "../models/components/organizationclientdelegationstatus.js";
import { OrganizationClientDeletePreflight } from "../models/components/organizationclientdeletepreflight.js";
import { RemoteSessionClient } from "../models/components/remotesessionclient.js";
import {
  AttachOrganizationRemoteSessionClientKeySetRequest,
  AttachOrganizationRemoteSessionClientKeySetSecurity,
} from "../models/operations/attachorganizationremotesessionclientkeyset.js";
import {
  CreateCimdOrganizationRemoteSessionClientRequest,
  CreateCimdOrganizationRemoteSessionClientSecurity,
} from "../models/operations/createcimdorganizationremotesessionclient.js";
import {
  CreateOrganizationRemoteSessionClientRequest,
  CreateOrganizationRemoteSessionClientSecurity,
} from "../models/operations/createorganizationremotesessionclient.js";
import {
  DeleteOrganizationRemoteSessionClientRequest,
  DeleteOrganizationRemoteSessionClientSecurity,
} from "../models/operations/deleteorganizationremotesessionclient.js";
import {
  DetachOrganizationRemoteSessionClientKeySetRequest,
  DetachOrganizationRemoteSessionClientKeySetSecurity,
} from "../models/operations/detachorganizationremotesessionclientkeyset.js";
import {
  GetOrganizationRemoteSessionClientRequest,
  GetOrganizationRemoteSessionClientSecurity,
} from "../models/operations/getorganizationremotesessionclient.js";
import {
  GetOrganizationRemoteSessionClientDelegationStatusRequest,
  GetOrganizationRemoteSessionClientDelegationStatusSecurity,
} from "../models/operations/getorganizationremotesessionclientdelegationstatus.js";
import {
  GetOrganizationRemoteSessionClientDeletePreflightRequest,
  GetOrganizationRemoteSessionClientDeletePreflightSecurity,
} from "../models/operations/getorganizationremotesessionclientdeletepreflight.js";
import {
  ListOrganizationRemoteSessionClientMcpServersRequest,
  ListOrganizationRemoteSessionClientMcpServersSecurity,
} from "../models/operations/listorganizationremotesessionclientmcpservers.js";
import {
  ListOrganizationRemoteSessionClientsRequest,
  ListOrganizationRemoteSessionClientsResponse,
  ListOrganizationRemoteSessionClientsSecurity,
} from "../models/operations/listorganizationremotesessionclients.js";
import {
  RemoveOrganizationRemoteSessionClientFromMcpServerRequest,
  RemoveOrganizationRemoteSessionClientFromMcpServerSecurity,
} from "../models/operations/removeorganizationremotesessionclientfrommcpserver.js";
import {
  RotateOrganizationRemoteSessionClientRequest,
  RotateOrganizationRemoteSessionClientSecurity,
} from "../models/operations/rotateorganizationremotesessionclient.js";
import {
  UpdateOrganizationRemoteSessionClientRequest,
  UpdateOrganizationRemoteSessionClientSecurity,
} from "../models/operations/updateorganizationremotesessionclient.js";
import { unwrapAsync } from "../types/fp.js";
import { PageIterator, unwrapResultIterator } from "../types/operations.js";

export class OrganizationRemoteSessionClients extends ClientSDK {
  /**
   * attachClientKeySet organizationRemoteSessionClients
   *
   * @remarks
   * Attach an organization JSON Web Key Set to a remote_session_client in the caller's organization, opting it into signing private_key_jwt assertions. Requires org:admin and the customer_managed_encryption_keys entitlement.
   */
  async attachKeySet(
    request: AttachOrganizationRemoteSessionClientKeySetRequest,
    security?: AttachOrganizationRemoteSessionClientKeySetSecurity | undefined,
    options?: RequestOptions,
  ): Promise<RemoteSessionClient> {
    return unwrapAsync(organizationRemoteSessionClientsAttachKeySet(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * createClient organizationRemoteSessionClients
   *
   * @remarks
   * Register a standalone remote_session_client under an existing remote_session_issuer in the caller's organization, with no user_session_issuer attachments. The client is project-scoped: it inherits a project-specific issuer's project, or the caller names a project (which must belong to the organization) when the issuer is organization-level. Requires org:admin.
   */
  async create(
    request: CreateOrganizationRemoteSessionClientRequest,
    security?: CreateOrganizationRemoteSessionClientSecurity | undefined,
    options?: RequestOptions,
  ): Promise<RemoteSessionClient> {
    return unwrapAsync(organizationRemoteSessionClientsCreate(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * createCimdClient organizationRemoteSessionClients
   *
   * @remarks
   * Register a standalone remote_session_client in Client ID Metadata Document (CIMD) mode under an existing remote_session_issuer in the caller's organization, with no user_session_issuer attachments. Speakeasy generates the client_id and hosts the metadata document; the issuer must advertise client_id_metadata_document_supported. The client is project-scoped: it inherits a project-specific issuer's project, or the caller names a project (which must belong to the organization) when the issuer is organization-level. Requires org:admin.
   */
  async createCimd(
    request: CreateCimdOrganizationRemoteSessionClientRequest,
    security?: CreateCimdOrganizationRemoteSessionClientSecurity | undefined,
    options?: RequestOptions,
  ): Promise<RemoteSessionClient> {
    return unwrapAsync(organizationRemoteSessionClientsCreateCimd(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * deleteClient organizationRemoteSessionClients
   *
   * @remarks
   * Soft-delete a remote_session_client in the caller's organization. Cascades to the remote_sessions minted against it. Requires org:admin.
   */
  async delete(
    request: DeleteOrganizationRemoteSessionClientRequest,
    security?: DeleteOrganizationRemoteSessionClientSecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(organizationRemoteSessionClientsDelete(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * detachClientKeySet organizationRemoteSessionClients
   *
   * @remarks
   * Detach the JSON Web Key Set from a remote_session_client in the caller's organization. Refused while the client declares token_endpoint_auth_method=private_key_jwt. A no-op when no set is attached. Requires org:admin and the customer_managed_encryption_keys entitlement.
   */
  async detachKeySet(
    request: DetachOrganizationRemoteSessionClientKeySetRequest,
    security?: DetachOrganizationRemoteSessionClientKeySetSecurity | undefined,
    options?: RequestOptions,
  ): Promise<RemoteSessionClient> {
    return unwrapAsync(organizationRemoteSessionClientsDetachKeySet(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getClient organizationRemoteSessionClients
   *
   * @remarks
   * Get a remote_session_client in the caller's organization by id. Requires org:read.
   */
  async get(
    request: GetOrganizationRemoteSessionClientRequest,
    security?: GetOrganizationRemoteSessionClientSecurity | undefined,
    options?: RequestOptions,
  ): Promise<RemoteSessionClient> {
    return unwrapAsync(organizationRemoteSessionClientsGet(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getClientDelegationStatus organizationRemoteSessionClients
   *
   * @remarks
   * Read sanitized delegation observations for the current upstream configuration in the last 30 days. Requires org:admin. Never exercises credentials; presence is not proof of future refresh success.
   */
  async getDelegationStatus(
    request: GetOrganizationRemoteSessionClientDelegationStatusRequest,
    security?:
      | GetOrganizationRemoteSessionClientDelegationStatusSecurity
      | undefined,
    options?: RequestOptions,
  ): Promise<OrganizationClientDelegationStatus> {
    return unwrapAsync(organizationRemoteSessionClientsGetDelegationStatus(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getClientDeletePreflight organizationRemoteSessionClients
   *
   * @remarks
   * Authoritative impact summary for deleting a remote_session_client: associated session count, affected MCP server names, and trusted identity-provider login references that must be explicitly unlinked before deletion. Requires org:read.
   */
  async getDeletePreflight(
    request: GetOrganizationRemoteSessionClientDeletePreflightRequest,
    security?:
      | GetOrganizationRemoteSessionClientDeletePreflightSecurity
      | undefined,
    options?: RequestOptions,
  ): Promise<OrganizationClientDeletePreflight> {
    return unwrapAsync(organizationRemoteSessionClientsGetDeletePreflight(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listClients organizationRemoteSessionClients
   *
   * @remarks
   * List the remote_session_clients registered with a given issuer in the caller's organization, each with its MCP server attachment count. Requires org:read.
   */
  async list(
    request: ListOrganizationRemoteSessionClientsRequest,
    security?: ListOrganizationRemoteSessionClientsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<
    PageIterator<
      ListOrganizationRemoteSessionClientsResponse,
      { cursor: string }
    >
  > {
    return unwrapResultIterator(organizationRemoteSessionClientsList(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listClientMcpServers organizationRemoteSessionClients
   *
   * @remarks
   * List the MCP servers a remote_session_client is attached to (resolved through user_session_issuers) in the caller's organization. Requires org:read.
   */
  async listMcpServers(
    request: ListOrganizationRemoteSessionClientMcpServersRequest,
    security?:
      | ListOrganizationRemoteSessionClientMcpServersSecurity
      | undefined,
    options?: RequestOptions,
  ): Promise<ListOrganizationMcpServersResult> {
    return unwrapAsync(organizationRemoteSessionClientsListMcpServers(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * removeClientFromMcpServer organizationRemoteSessionClients
   *
   * @remarks
   * Detach a remote_session_client from an MCP server (clears the MCP server's user_session_issuer link) in the caller's organization. Requires org:admin.
   */
  async removeFromMcpServer(
    request: RemoveOrganizationRemoteSessionClientFromMcpServerRequest,
    security?:
      | RemoveOrganizationRemoteSessionClientFromMcpServerSecurity
      | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(organizationRemoteSessionClientsRemoveFromMcpServer(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * rotateClient organizationRemoteSessionClients
   *
   * @remarks
   * Re-register a dynamically registered remote_session_client with its issuer in place, replacing the client_id and secret while keeping the row's id, issuer bindings, MCP server attachments, and key set links. Every remote session minted against the old client_id is revoked, so users reconnect once. Use when the issuer reports the registration expired (upstream_rejected_at is set) or to rotate proactively. The replacement is registered at the registration_endpoint the client's issuer publishes, so the issuer must publish one. Requires org:admin.
   */
  async rotate(
    request: RotateOrganizationRemoteSessionClientRequest,
    security?: RotateOrganizationRemoteSessionClientSecurity | undefined,
    options?: RequestOptions,
  ): Promise<RemoteSessionClient> {
    return unwrapAsync(organizationRemoteSessionClientsRotate(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * updateClient organizationRemoteSessionClients
   *
   * @remarks
   * Update a remote_session_client's non-secret fields in the caller's organization. Requires org:admin.
   */
  async update(
    request: UpdateOrganizationRemoteSessionClientRequest,
    security?: UpdateOrganizationRemoteSessionClientSecurity | undefined,
    options?: RequestOptions,
  ): Promise<RemoteSessionClient> {
    return unwrapAsync(organizationRemoteSessionClientsUpdate(
      this,
      request,
      security,
      options,
    ));
  }
}
